export default class NotificationsManager {
  static confirm(message, content = "Weet je zeker dat je deze actie wilt uitvoeren?") {
    return new Promise((resolve, reject) => {
      window.main?.$confirm({
        title: message,
        content,
        okText: "Verwijderen",
        okType: "danger",
        cancelText: "Annuleren",
        onOk() {
          resolve();
        },
        onCancel() {
          reject();
        },
      });
    });
  }

  static success(response) {
    if (window.main?.$store.hasModule("$_notifications")) {
      window.main?.$store.dispatch("$_notifications/displaySuccessNotifications", response, { root: true });
    }
  }

  static error(error) {
    if (window.main?.$store.hasModule("$_notifications")) {
      window.main?.$store.dispatch("$_notifications/displayErrorNotifications", error, { root: true });
    }
    // Handle <FormPage> error popup if needed
    if (window.main?.$store.hasModule("$_form_page")) {
      window.main?.$store.commit("$_form_page/SET_AXIOS_ERROR", error, { root: true });
    }
  }
}
